var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgInsuranceCompany(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12588",
    d: "M0 0h24v24H0z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12589",
    d: "M4 16V7.33",
    fill: "none",
    stroke: "#1f76b3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12590",
    d: "M20 7.33V16",
    fill: "none",
    stroke: "#1f76b3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12591",
    d: "M22 8.667L12 2 2 8.667",
    fill: "none",
    stroke: "#1f76b3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12592",
    d: "M8 10v4",
    fill: "none",
    stroke: "#1f76b3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12593",
    d: "M12 10v4",
    fill: "none",
    stroke: "#1f76b3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12594",
    d: "M16 10v4",
    fill: "none",
    stroke: "#1f76b3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12595",
    d: "M9 18l2 2-2 2",
    fill: "none",
    stroke: "#1f76b3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12596",
    d: "M11 20H3",
    fill: "none",
    stroke: "#1f76b3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12597",
    d: "M21 20h-6",
    fill: "none",
    stroke: "#1f76b3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })));
}

export default SvgInsuranceCompany;


//////////////////
// WEBPACK FOOTER
// ./src/icons/insuranceCompany.svg
// module id = 822
// module chunks = 101